import React from "react";
import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from "recharts";
import { IndianRupee } from "lucide-react";

const tooltipStyle = {
  backgroundColor: "var(--card-bg, #fff)",
  border: "1px solid var(--border-primary, #e5e7eb)",
  borderRadius: "8px",
  fontSize: "12px",
  padding: "8px 12px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
  color: "var(--text-primary, #111827)",
};

/**
 * PlatformRevenueChart — Area chart showing total platform revenue over time.
 */
const PlatformRevenueChart = ({ data = [] }) => (
  <div className="sa-card">
    <div className="sa-card-head">
      <div className="sa-card-head-left">
        <div className="sa-card-icon emerald"><IndianRupee size={18} /></div>
        <div>
          <div className="sa-card-title">Platform Revenue</div>
          <div className="sa-card-subtitle">Monthly MRR across all tenants</div>
        </div>
      </div>
    </div>
    <div className="sa-card-body">
      {data.length === 0 ? (
        <div className="sa-empty">No revenue data</div>
      ) : (
        <ResponsiveContainer width="100%" height={240}>
          <AreaChart data={data} margin={{ top: 8, right: 8, left: -10, bottom: 0 }}>
            <defs>
              <linearGradient id="saRevGrad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#2563eb" stopOpacity={0.15} />
                <stop offset="95%" stopColor="#2563eb" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--border-primary, #e5e7eb)" vertical={false} />
            <XAxis
              dataKey="month"
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12, fill: "var(--text-tertiary, #94a3b8)" }}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 11, fill: "var(--text-tertiary, #94a3b8)" }}
              tickFormatter={(v) => (v >= 1000 ? `${v / 1000}K` : v)}
            />
            <Tooltip contentStyle={tooltipStyle} formatter={(v) => [`₹${v.toLocaleString("en-IN")}`, "Revenue"]} />
            <Area
              type="monotone"
              dataKey="revenue"
              stroke="#2563eb"
              strokeWidth={2.5}
              fill="url(#saRevGrad)"
              dot={false}
              activeDot={{ r: 5, strokeWidth: 2, fill: "#fff" }}
            />
          </AreaChart>
        </ResponsiveContainer>
      )}
    </div>
  </div>
);

export default PlatformRevenueChart;
